const config = {
  defaults: {
    namespace: "Team-Work APP",
  },
};

export default config;
